<template>
    <div class="bg">
        <mu-flexbox>
            <mu-flexbox-item>
                <mu-flexbox class="rc_wraper" align="stretch">
                <mu-flexbox-item textAlign="left" grow="2">
                    <div class="text-info">本金(元)</div>
                    <div class="text-value">{{value.amount}}</div>
                </mu-flexbox-item>
                <mu-flexbox-item textAlign="left">
                    <div class="text-info">期数</div>
                    <div class="text-value">{{value.periods}}</div>
                </mu-flexbox-item>
                <mu-flexbox-item textAlign="left" grow="2">
                    <div class="text-info">申请时间</div>
                    <div class="text-value">{{value.applyTime | dataTimeFilter}}</div>
                </mu-flexbox-item>
                </mu-flexbox>
                <div class="text-bottom">
                    逾期总额：<span style="color: #d0021b">{{value.periodAmount}}元</span>
                </div>
            </mu-flexbox-item>

        </mu-flexbox>
    </div>
</template>

<script>
    import MuFlexbox from "../../../components/flexbox/flexbox";
    import MuFlexboxItem from "../../../components/flexbox/flexboxItem";
    import CheckBox from "./CheckBox";
    export default {
        name: "repayCard",
        components: {MuFlexboxItem, MuFlexbox, CheckBox},
        data: function() {
            return {

            }
        },
        props:{
            value: {
                type: Object,
                defaultValue: {},
            }
        },
        filters:{
            dataTimeFilter: (val) =>{
                let d = new Date(val)
                return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
            }
        },
        methods: {
            changeCard: function(val){
            },

        }
    }
</script>

<style scoped>
.bg{
    background: #fff;
    padding: 16px 0;
    padding-left: 24px;
    border: 1px solid #dbdee2;
    border-bottom-left-radius: 13px;
    border-top-right-radius: 13px;
    position: relative;
}

.rc_wraper{
    border-bottom: 1px solid #dbdee2;
    padding: 16px 0;
}

.text-info{
    font-size: 12px;
    color: #9a9dad;
}
.text-value{
    margin-top: 8px;
    font-size: 18px;
    color: #373f5f;
    line-height: 18px;
}
.text-bottom{
    margin-top: 16px;
    font-size: 12px;
    color: #9a9dad;
    line-height: 12px;
    text-align: left;
}

</style>